module.exports = __webpack_public_path__ + "static/media/profile.bc70bab0.png";